import { render } from "./OfferDetails.vue?vue&type=template&id=1e92a4e0&scoped=true&ts=true"
import script from "./OfferDetails.vue?vue&type=script&lang=ts"
export * from "./OfferDetails.vue?vue&type=script&lang=ts"

import "./OfferDetails.vue?vue&type=style&index=0&id=1e92a4e0&scoped=true&lang=scss"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e92a4e0"]])

export default __exports__